import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaList, FaPen, FaPlus, FaThumbsUp } from 'react-icons/fa';
import { ImCancelCircle } from 'react-icons/im';
import Alert from '../../../components/Alert';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import '../../../css/financeiro-parcela-pagar.css';

export default function PainelChecklist() {
    const token = localStorage.getItem('token');
    const empresa = localStorage.getItem("empresa");
    const perfil = localStorage.getItem("perfil");
    const params = new URLSearchParams(window.location.search);
    const idEvento = params.get('idEvento');
    const [filtro, setFiltro] = useState({
        prazo: "2",
        evento: idEvento
    });
    const [buscando, setBuscando] = useState(false);
    const [checklists, setChecklists] = useState([]);
    const [nomeEvento, setNomeEvento] = useState('');
    const history = useHistory();

    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = id => setSelectedIds(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const toggleAll = () => paginados.length > 0 && selectedIds.size === paginados.length ? setSelectedIds(new Set()) : setSelectedIds(new Set(paginados.map(r => r.id)));
    const total = checklists.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = checklists.slice((page - 1) * pageSize, page * pageSize);
    const selectedArr = [...selectedIds];

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoChecklist',
            token: token,
            params: {
                empresa: empresa,
                ...filtro,
            },
            signal: controllerRef.current.signal
        })
            .then(response => {
                setChecklists(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setBuscando(false);
            });
    };

    const buscarEvento = () => {
        if (idEvento) {
            api({
                method: 'get',
                action: '/evento/' + idEvento,
                token: token
            })
                .then(response => {
                    setNomeEvento(response.data.data.nome);
                }).catch(err => {
                    //console.log(err)
                });
        }
    };

    const excluir = (id) => {
        Alert({
            icon: "error",
            confirmButton: "Cancelar",
            denyButton: <><FaThumbsUp size={20} /> Excluir</>,
            title: "Excluir Checklist",
            html: `<p>Você tem certeza que deseja excluir este checklist?</p>
                   <p><strong>Esta ação irá deletar:</strong></p>
                   <ul>
                       <li>O checklist principal</li>
                       <li>Todos os itens do checklist</li>
                       <li>Todo o histórico de atividades</li>
                   </ul>
                   <p class="text-danger"><strong>Esta ação não pode ser desfeita!</strong></p>`,
            callBack: (result) => {
                if (result.isDenied) {
                    api({
                        method: 'delete',
                        action: '/eventoChecklist/' + id,
                        token: token
                    })
                        .then(function (response) {
                            toast.success('Checklist excluído com sucesso!');
                            setSelectedIds(new Set());
                            buscar();
                        })
                        .catch(function (error) {
                            toast.error('Erro: ' + (error.response?.data?.error ?? "ao excluir checklist"));
                        });
                }
            }
        });
    };

    useEffect(() => {
        buscarEvento();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
        // eslint-disable-next-line
        []);

    const getEventoLabel = (row) => {
        if (row.evento?.nome) {
            if (row.evento?.identificacao) {
                return (row.evento?.codigo ?? "") + ' - ' + row.evento.identificacao + ' - ' + (row.evento?.nome ?? "");
            } else {
                return (row.evento?.codigo ?? "") + ' - ' + (row.evento?.nome ?? "");
            }
        }
        return "";
    };

    const getClienteLabel = (row) => {
        if (row.evento?.cliente?.nome) {
            if (row.evento?.cliente?.municipio) {
                return row.evento.cliente.codigo + ' - ' + row.evento.cliente.nome + ' - ' + row.evento.cliente.municipio + ' - ' + row.evento.cliente.uf;
            } else {
                return row.evento.cliente.codigo + ' - ' + row.evento.cliente.nome;
            }
        }
        return "";
    };

    const getResponsavelLabel = (row) => {
        if (row.evento?.responsavel?.nome) {
            return row.evento.responsavel.codigo + ' - ' + row.evento.responsavel.nome;
        }
        return "";
    };

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Checklist{nomeEvento ? ` - ${nomeEvento}` : ''}</h1></div>
                    <div className="fin-pp__actions">
                        {['admin', 'diretor', 'gerenteprojeto', 'gerentefinanceiro', 'backoffice', 'gerenteevento', 'gerenteeventointernacional', 'evento', 'gerentersvp', 'coordenadorrsvp'].includes(perfil) ?
                            <Link to={idEvento ? `/cadastroEventoChecklist?idEvento=${idEvento}` : "/cadastroEventoChecklist/"} className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill"><FaPlus size={14} /> Novo Checklist</Link> :
                            null}
                        {['admin', 'diretor', 'gerenteprojeto'].includes(perfil) ?
                            <Link to="/eventoChecklistModelo" className="fin-pp__btn fin-pp__btn--pill" style={{ marginLeft: 8 }}><FaList size={14} /> Modelos de Checklist</Link> :
                            null}
                    </div>
                </div>

                {selectedArr.length === 1 && (
                    <div style={{ marginBottom: 8, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                        <Link to={"/alterarEventoChecklist/" + selectedArr[0]} className="fin-pp__btn fin-pp__btn--sm fin-pp__btn--primary">
                            <FaPen size={14} /> Alterar
                        </Link>
                        <button type="button" className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm" onClick={() => excluir(selectedArr[0])}>
                            <ImCancelCircle size={14} /> Excluir
                        </button>
                    </div>
                )}

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead><tr>
                                <th style={{ width: 40 }}><input type="checkbox" checked={paginados.length > 0 && selectedIds.size === paginados.length} onChange={toggleAll} /></th>
                                <th style={{ width: 60 }}></th>
                                <th>Modelo</th>
                                <th>Evento</th>
                                <th>Cliente</th>
                                <th>Responsável</th>
                            </tr></thead>
                            <tbody>
                                {buscando ? <tr><td colSpan={6} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0 ? <tr><td colSpan={6} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td><input type="checkbox" checked={selectedIds.has(row.id)} onChange={() => toggleSelect(row.id)} /></td>
                                                <td><Link to={"/alterarEventoChecklist/" + row.id} className="fin-pp__rowbtn"><FaPen size={14} /></Link></td>
                                                <td>{row.modelo?.nome ?? ""}</td>
                                                <td>{getEventoLabel(row)}</td>
                                                <td>{getClienteLabel(row)}</td>
                                                <td>{getResponsavelLabel(row)}</td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize} onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option><option value={30}>30 / pág</option><option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
